import Vuex from 'vuex'

import { authentication } from '@/store/modules/authentication/authentication';
import { alert } from '@/store/modules/alert';
import { handleData } from '@/store/modules/handleData';
import { handleData2 } from '@/store/modules/handleData2';
import { header } from '@/store/modules/header';
import { validate } from '@/store/modules/validate';

// Danh muc
import { phuongXa } from '@/store/modules/shareData/phuongXa'
import { nhomDanToc } from '@/store/modules/danhmuc/dungchung/nhomDanToc'
import { danToc } from '@/store/modules/danhmuc/dungchung/danToc'
import { loaiDiaDiem } from '@/store/modules/danhmuc/dungchung/loaiDiaDiem'
import { phanLoaiDiaDiem } from '@/store/modules/danhmuc/dungchung/phanLoaiDiaDiem'
import { dmKy } from './modules/danhmuc/dungchung/dmKy';
import { quyenQT } from './modules/quantri/quyen';
import { nguoiDung } from './modules/danhmuc/dungchung/nguoiDung'

//DungChung 
import { chucDanh } from '@/store/modules/danhmuc/dungchung/chucDanh'
import { donViQT } from '@/store/modules/danhmuc/dungchung/donVi'
import { duongPhoDM } from '@/store/modules/danhmuc/dungchung/duongPho'
import { khomApDM } from '@/store/modules/danhmuc/dungchung/khomAp'
import { phuongXaDM } from '@/store/modules/danhmuc/dungchung/phuongXa'
import { quanHuyenDM } from '@/store/modules/danhmuc/dungchung/quanHuyen'
import { tinhTPDM } from '@/store/modules/danhmuc/dungchung/tinhTp'
import { toDanPhoDM } from '@/store/modules/danhmuc/dungchung/toDanPho'
import { menuDanhSach } from './modules/menu/menu'
import { congTy } from './modules/danhmuc/dungchung/congTy'

//Giao Duc
import { monHocGD } from './modules/danhmuc/giaoduc/monHocGD'
import { mucTruongChuanGD } from './modules/danhmuc/giaoduc/mucTruongChuanGD'
import { quyMoTruongChuanGD } from './modules/danhmuc/giaoduc/quyMoTruongChuanGD'
import { kyThiHSGGD } from './modules/danhmuc/giaoduc/kyThiHSGGD'
import { thanhTichHSGGD } from './modules/danhmuc/giaoduc/thanhTichHSGGD'
import { phanLoaiTruongGD } from './modules/danhmuc/giaoduc/phanLoaiTruongGD'
import { phanLoaiTruongMamNonGD } from './modules/danhmuc/giaoduc/phanLoaiTruongMamNonGD'
import { loaiHinhTruongMamNonGD } from './modules/danhmuc/giaoduc/loaiHinhTruongMamNonGD'

import { truongMamNonGD } from './modules/giaoduc/mamnon/truongMamNonQGGD'
import { truongMamnonPhonghoc } from './modules/giaoduc/mamnon/truongMamnon_Phonghoc'
import { truongMamnonGiaovien } from './modules/giaoduc/mamnon/truongMamnon_Giaovien'
import { truongMamnonHocsinh } from './modules/giaoduc/mamnon/truongMamnon_Hocsinh'
import { truongMamnonLophoc } from './modules/giaoduc/mamnon/truongMamnon_LopHoc'
import { truongMamNonGD_v2 } from './modules/giaoduc/mamnon/truongMamNonQGGD_v2'

import { truongQGGD } from './modules/giaoduc/caphockhac/truongQGGD'
import { hocSinhGioiGD } from './modules/giaoduc/hocSinhGioiGD'
import { truongchuanQuocgiaLophoc } from './modules/giaoduc/caphockhac/truongchuanQuocgia_Lophoc'
import { truongchuanQuocgiaPhonghoc } from './modules/giaoduc/caphockhac/truongchuanQuocgia_Phonghoc'
import { truongchuanQuocgiaGiaovien } from './modules/giaoduc/caphockhac/truongchuanQuocgia_Giaovien'
import { truongchuanQuocgiaHocsinh } from './modules/giaoduc/caphockhac/truongchuanQuocgia_Hocsinh'

import { truongQGGD_v2 } from './modules/giaoduc/caphockhac/truongQGGD_v2'

import { baoCaoGD } from './modules/giaoduc/baoCaoGD'

//Co So Y Te
import { trinhDoChuyenMonY } from '@/store/modules/danhmuc/cosoyte/trinhDoChuyenMonY'
import { trinhDoChuyenMonCoSoDuoc } from '@/store/modules/danhmuc/cosoyte/trinhDoChuyenMonCoSoDuoc'
import { loaiHinhHanhNgheY } from '@/store/modules/danhmuc/cosoyte/loaiHinhHanhNgheY'
import { hinhThucKinhDoanhCoSoDuoc } from '@/store/modules/danhmuc/cosoyte/hinhThucKinhDoanhCoSoDuoc'
import { chuyenKhoaY } from '@/store/modules/danhmuc/cosoyte/chuyenKhoaY'
import { benhVien } from '@/store/modules/cosoyte/benhVien'
import { coSoDuoc } from '@/store/modules/cosoyte/coSoDuoc'
import { coSoYTeTuNhan } from './modules/cosoyte/coSoYTeTuNhan'
import { tramYTe } from './modules/cosoyte/tramYTe'

//Di San Van Hoa
import { loaiDiTichVH } from './modules/danhmuc/vanhoa/loaiDiTich'
import { loaiHinhDiTichVH } from './modules/danhmuc/vanhoa/loaiHinhDiTich'
import { boMonTheThaoVH } from './modules/danhmuc/vanhoa/boMonTheThao'
import { hangCanTheThaoVH } from './modules/danhmuc/vanhoa/hangCanTheThao'
import { phamViGiaiTheThaoVH } from './modules/danhmuc/vanhoa/phamViGiaiTheThao'
import { nhomGiaiThiDauTheThaoVH } from './modules/danhmuc/vanhoa/nhomGiaiThiDauTheThao'
import { nhomThanhTichTheThaoVH } from './modules/danhmuc/vanhoa/nhomThanhTichTheThao'


import { diTichDiSanVH } from './modules/dulich/diTichDiSanVH'
import { diemDuLichVH } from './modules/dulich/diemDuLichVH'
import { giaiThiDauTheThaoVH } from './modules/thethao/giaiThiDauTheThao'
import { thanhTichThiDauTheThaoVH } from './modules/thethao/thanhTichThiDauTheThao'
import { huanLuyenVienTheThaoVH } from './modules/thethao/huanLuyenVienTheThao'
import { huanLuyenVienBoMonTheThaoVH } from './modules/thethao/huanLuyenVienBoMonTheThao'
import { vanDongVienTheThaoVH } from './modules/thethao/vanDongVienTheThao'
import { vanDongVienBoMonTheThaoVH } from './modules/thethao/vanDongVienBoMonTheThao'
import { thanhTichCaNhanTheThaoVH } from './modules/thethao/thanhTichCaNhanTheThao'
import { thanhTichTongHopTheThaoVH } from './modules/thethao/thanhTichTongHopTheThao'
import { phongTraoTheThaoVH } from './modules/thethao/phongTraoTheThao'
import { hoatDongDuLichVH } from './modules/dulich/hoatDongDuLich'
import { baoLucGiaDinhVH } from './modules/vanhoa/baoLucGiaDinh'
import { giaDinhVanHoaVH } from './modules/vanhoa/giaDinhVanHoa'
import { thethaoDoi } from './modules/thethao/doiTheThao'
import { thethaoDoiThanhTich } from './modules/thethao/doiTheThaoThanhTich'
import { thethaoSunghiep } from './modules/thethao/thethaoSunghiep'

//Co So Thiet Yeu
import { tieuChuanKhachSan } from './modules/danhmuc/dichvuthietyeu/tieuChuanKhachSan'
import { nganHang } from './modules/danhmuc/dichvuthietyeu/nganHang'
import { atm } from './modules/dichvuthietyeu/atm'
import { khachSan } from './modules/dichvuthietyeu/khachSan'
import { tramXang } from './modules/dichvuthietyeu/tramXang'
import { nhaXe } from './modules/dichvuthietyeu/nhaXe'
import { benXe } from './modules/dichvuthietyeu/benXe'
import { diemTienIch } from './modules/dichvuthietyeu/diemTienIch'
import { diemWifiCongCong } from './modules/dichvuthietyeu/diemWifiCongCong'
import { nhaHang } from './modules/dichvuthietyeu/nhaHang'

//He Thong Chieu Sang
import { congsuatDen } from './modules/danhmuc/hethongchieusang/congsuatDen'
import { loaiDen } from './modules/danhmuc/hethongchieusang/loaiDen'
import { loaiTruDen } from './modules/danhmuc/hethongchieusang/loaiTruDen'
import { loaiTuyenduong } from './modules/danhmuc/hethongchieusang/loaiTuyenduong'
import { tinhTrangDen } from './modules/danhmuc/hethongchieusang/tinhTrangDen'
import { tinhTrangTruDen } from './modules/danhmuc/hethongchieusang/tinhTrangTruDen'
import { tuyenDenduong } from './modules/hethongchieusang/tuyenDenduong'
import { trudenChieusang } from './modules/hethongchieusang/trudenChieusang'
import { suachuaDenChieusang } from './modules/hethongchieusang/suachuaDenChieusang'

//Tai chinh - Ke hoach
import { chitieuThuchiNgansach } from './modules/danhmuc/taichinhkehoach/chitieuThuchiNgansach'
import { thuchiNgansach } from './modules/taichinhkehoach/thuchiNgansach'
import { tiendoDautu } from './modules/danhmuc/taichinhkehoach/tiendoDautu'
import { duanDautu } from './modules/taichinhkehoach/duanDautu'
import { kehoachVon } from './modules/taichinhkehoach/kehoachVon'
import { tiendoGiaingan } from './modules/taichinhkehoach/tiendoGiaingan'
import { baocaoKehoachvon } from './modules/taichinhkehoach/baocaoKehoachvon'
import { baocaoKtxh } from './modules/taichinhkehoach/baocaoKtxh'

//Xu Ly Rac Thai
import { loaiTuyenduongQuetRac } from './modules/danhmuc/xulyracthai/loaiTuyenduongQuetRac'
import { tuyenduongThugomrac } from './modules/danhmuc/xulyracthai/tuyenduongThugomrac'
import { diabanThugomrac } from './modules/danhmuc/xulyracthai/diabanThugomrac'
import { lichQuetRac } from './modules/xulyracthai/lichQuetRac'
import { lichThugomrac } from './modules/xulyracthai/lichThugomrac'
import { lichNaovetHoga } from './modules/xulyracthai/lichNaovetHoga'
import { lichVesinhDothiKhac } from './modules/xulyracthai/lichVesinhDothiKhac'
import { nguonvonDautu } from './modules/taichinhkehoach/nguonVonDauTu'



const debug = process.env.NODE_ENV !== 'production'
export const store = new Vuex.Store({
	modules: {
		authentication,
		alert,
		handleData, handleData2,
		header,
		validate,
		menuDanhSach,
		quyenQT,
		// Danh muc
		nguoiDung,
		phuongXa,
		nhomDanToc, danToc, loaiDiaDiem, phanLoaiDiaDiem, congTy,
		dmKy,
		chucDanh,donViQT,duongPhoDM,khomApDM,phuongXaDM,quanHuyenDM,tinhTPDM,toDanPhoDM,

		// Van Hoa
		loaiDiTichVH, loaiHinhDiTichVH, 
		hoatDongDuLichVH, baoLucGiaDinhVH, giaDinhVanHoaVH, 	
		diTichDiSanVH,diemDuLichVH,	
		boMonTheThaoVH, hangCanTheThaoVH, phamViGiaiTheThaoVH, nhomGiaiThiDauTheThaoVH, nhomThanhTichTheThaoVH,
		giaiThiDauTheThaoVH, thanhTichThiDauTheThaoVH, huanLuyenVienTheThaoVH, huanLuyenVienBoMonTheThaoVH, vanDongVienTheThaoVH, vanDongVienBoMonTheThaoVH, 
		thethaoDoi, thethaoDoiThanhTich, thanhTichCaNhanTheThaoVH, thanhTichTongHopTheThaoVH, phongTraoTheThaoVH, thethaoSunghiep,
		//Co so y te
		trinhDoChuyenMonY,
		trinhDoChuyenMonCoSoDuoc,
		loaiHinhHanhNgheY,
		hinhThucKinhDoanhCoSoDuoc,
		chuyenKhoaY,
		tieuChuanKhachSan,
		benhVien,
		coSoDuoc,
		coSoYTeTuNhan,
		tramYTe,

		//Dich vu thiet yeu
		nganHang,
		atm,
		khachSan,
		tramXang,
		nhaXe,
		benXe,
		diemTienIch,
		diemWifiCongCong,
		nhaHang,
		//Giao Duc
		monHocGD, mucTruongChuanGD, quyMoTruongChuanGD, kyThiHSGGD, thanhTichHSGGD, phanLoaiTruongGD, 
		phanLoaiTruongMamNonGD, loaiHinhTruongMamNonGD,
		truongQGGD, truongchuanQuocgiaLophoc, truongchuanQuocgiaPhonghoc, truongchuanQuocgiaGiaovien,
		hocSinhGioiGD,truongchuanQuocgiaHocsinh,
		truongMamNonGD, truongMamnonPhonghoc, truongMamnonGiaovien, truongMamnonHocsinh, truongMamnonLophoc,
		truongQGGD_v2, truongMamNonGD_v2,
		baoCaoGD,

		//He Thong Chieu Sang
		congsuatDen, loaiDen, loaiTruDen, loaiTuyenduong, tinhTrangDen, tinhTrangTruDen,
		tuyenDenduong, trudenChieusang, suachuaDenChieusang,

		//Xu Ly RacThai
		loaiTuyenduongQuetRac, tuyenduongThugomrac, diabanThugomrac, 
		lichQuetRac, lichThugomrac, lichNaovetHoga, lichVesinhDothiKhac,

		//Tai chinh - Ke hoach
		chitieuThuchiNgansach, tiendoDautu,
		thuchiNgansach, nguonvonDautu,  duanDautu, kehoachVon, tiendoGiaingan, baocaoKehoachvon, baocaoKtxh
	},
	strict: debug
});
